import React from 'react';
import styled from "styled-components";
import {FilterDispatcherContext} from "@providers/filters";
import Selection from "@molecules/selection/selection";
import {Container as SelectionLists} from "@molecules/selection/components/lists";
import {CheckboxGroupBox, CheckboxGroupLabel, CheckboxLabelTitle} from "@atoms/checkbox.list.group";
import {updateFacilitiesOptions} from "@hooks/facilities";

function FacilitiesFilter(props) {
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    const {show, options, selected_items} = props.items;

    const selectedItemsCopy = [...selected_items];

    //console.log(show, options, selected_items)

    function handleChange(data) {
        if (JSON.stringify(data.items) !== JSON.stringify(selectedItemsCopy)) {
            const getUpdateFacilitiesOptions = updateFacilitiesOptions(options, data.items);

            filterDispatcher({
                type: 'FACILITIES_OPTIONS',
                payload: {
                    options: getUpdateFacilitiesOptions.options,
                    selected_items: data.items,
                    otherFacilityFilters: getUpdateFacilitiesOptions.otherFacilityFilters,
                    show: true
                }
            });
        }
    }

    return (
        <Container className={(show ? 'd-block' : 'd-none') + ' ' + (typeof props.className !== "undefined" ? props.className : '')}>
            <Selection
                type="multiple"
                name={props.name ?? "facilities"}
                options={options}
                selected_items={selected_items}
                label="ویژگی‌های مهم"
                onChange={(data) => handleChange(data)}
                caption_show={props.caption_show ?? undefined}
                select_optional={true}
                perfectScrollbar={false}
                showLabelAndSelected={!!(props.showLabelAndSelected)}
            />
        </Container>
    )
}

export default FacilitiesFilter

// styles
const Container = styled.div`
    .selection-lists {
        padding: 0 24px;
    }
    
    ${SelectionLists} {
        display: flex;
        flex-wrap: wrap;
        padding-top: 0;
        margin-right: -8px;
        margin-left: -8px;
    }
    
    ${CheckboxGroupBox} {
        margin-top: 16px;
        width: 33%;
        padding-right: 8px;
        padding-left: 8px;
        
        ${CheckboxGroupLabel} {
            height: 100%;
            min-width: 80px;
            padding: 16px 0;
            
            ${CheckboxLabelTitle} {
                margin-top: 4px;
            }
        }
    }
`;